var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranslate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_1690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8873 21.75H22.4998L17.9998 10.5H16.2373L11.7373 21.75H13.3498L14.5498 18.75H19.6873L20.8873 21.75ZM15.1498 17.25L17.1148 12.33L19.0873 17.25H15.1498Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.25V3.75H8.25V1.5H6.75V3.75H1.5V5.25H9.555C9.1425 6.9675 8.3175 8.55 7.1625 9.885C6.405 8.9475 5.8275 7.89 5.445 6.75H3.87C4.3425 8.28 5.1075 9.6975 6.12 10.935C5.0025 12.0225 3.69 12.8925 2.25 13.5L2.8125 14.895C4.425 14.2125 5.895 13.23 7.1475 12C8.37 13.245 9.8475 14.2275 11.4675 14.88L12 13.5C10.5525 12.9375 9.2475 12.0825 8.16 10.9725C9.5925 9.3375 10.605 7.3725 11.1 5.25H13.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_1690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate);
export default __webpack_public_path__ + "static/media/translate.2d932bbbbf2700b6385507911516609b.svg";
export { ForwardRef as ReactComponent };